import React from 'react';

import { MenuItem } from '@mui/material';
import { IconMenuItem } from 'mui-nested-menu';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { CustomizedTooltip } from 'components/common';

const MENU_FONT_SIZE = '13px';
const MENU_ICON_SIZE = '17px';

const iconMenuItemStyles = {
    '& .MuiTypography-root': {
        fontSize: MENU_FONT_SIZE,
        position: 'relative',
        color: `var(--menu-destructive-fg)`,
        top: '1px',
    },
    '& .MuiBox-root': {
        alignItems: 'center',
    },
};

interface Props {
    isOwner: boolean;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

export const DeleteViewMenuItem = ({ isOwner, onClick }: Props) => {
    const deleteMenuItem = (
        <IconMenuItem
            sx={iconMenuItemStyles}
            leftIcon={
                <MuiIcon
                    icon={'delete'}
                    type={'outlined'}
                    fontSize={MENU_ICON_SIZE}
                    color={`var(--menu-destructive-fg)`}
                />
            }
            label={'Delete view'}
        />
    );

    if (isOwner) {
        return (
            <MenuItem onClick={onClick}>
                {deleteMenuItem}
            </MenuItem>
        );
    }

    return (
        <CustomizedTooltip
            tooltipPosition={TooltipPosition.Right}
            tooltipContent={"You can't delete this view because you don't own it"}
            triggerElement={
                <MenuItem disabled={true}>
                    {deleteMenuItem}
                </MenuItem>
            }
        />
    );
};
